import { render, staticRenderFns } from "./creatAttr.vue?vue&type=template&id=565f84de&scoped=true"
import script from "./creatAttr.vue?vue&type=script&lang=js"
export * from "./creatAttr.vue?vue&type=script&lang=js"
import style0 from "./creatAttr.vue?vue&type=style&index=0&id=565f84de&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565f84de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('565f84de')) {
      api.createRecord('565f84de', component.options)
    } else {
      api.reload('565f84de', component.options)
    }
    module.hot.accept("./creatAttr.vue?vue&type=template&id=565f84de&scoped=true", function () {
      api.rerender('565f84de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen-product/components/creatAttr.vue"
export default component.exports